import api from './http.js'
// 登录方法
export function login(phone,verifyCode) {
    const data = {
        phone,
        verifyCode,
		platForm:0
    }
    return api.post('/app/login/appLogin',data)
}

// 登录方法
export function login1(userName,password) {
    const data = {
		userName,
        password
    }
    return api.post('/app/login/yhLoginByPassword',data)
}
// 退出方法
export function logout() {
    return api.post('/app/login/logout')
}

